export const version = {
  timeStamp: '2026-06-22 02:43:25 PM ',
  version: '0.0.5',
};
